import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const StopClockIcon = ({
  color = RoutalPalette.primary80,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 12 13" style={{ width: `12px`, height: `12px`, ...props.style }}>
      <g clip-path="url(#clip0_2201_37600)" fill="none">
        <path
          d="M6.00001 11.93C8.61784 11.93 10.74 9.80783 10.74 7.19C10.74 4.57217 8.61784 2.45 6.00001 2.45C3.38218 2.45 1.26001 4.57217 1.26001 7.19C1.26001 9.80783 3.38218 11.93 6.00001 11.93Z"
          stroke={color}
          stroke-miterlimit="10"
        />
        <path d="M6 2.45V0.800003" stroke={color} stroke-miterlimit="10" />
        <path d="M6 7.08001V4.46001" stroke={color} stroke-miterlimit="10" stroke-linecap="round" />
        <path d="M4.77002 1.07001H7.23002" stroke={color} stroke-miterlimit="10" stroke-linecap="round" />
        <path
          d="M6.00008 8.11C6.50818 8.11 6.92008 7.69811 6.92008 7.19C6.92008 6.6819 6.50818 6.27 6.00008 6.27C5.49198 6.27 5.08008 6.6819 5.08008 7.19C5.08008 7.69811 5.49198 8.11 6.00008 8.11Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2201_37600">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
